import React from 'react';

function CopyIcon({ classes = "w-6 h-6", strokeSize = "2.5" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 35 42"
      strokeWidth={strokeSize}
      stroke="currentColor"
      className={classes}
      aria-hidden="true" // Hide from screen readers as button has aria-label
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M27.2001 2.09998H8.80005C8.52391 2.09998 8.30005 2.32383 8.30005 2.59998V33.1C8.30005 33.3761 8.52391 33.6 8.80005 33.6H33.0001C33.2762 33.6 33.5001 33.3761 33.5001 33.1V8.39998M27.2001 2.09998L33.5001 8.39998M27.2001 2.09998V7.89998C27.2001 8.17612 27.4239 8.39998 27.7001 8.39998H33.5001"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.35 8.40002H2.5C2.22386 8.40002 2 8.62388 2 8.90002V39.4C2 39.6762 2.22386 39.9 2.5 39.9H26.7C26.9761 39.9 27.2 39.6762 27.2 39.4V32.55"
      />
    </svg>
  );
}

export default CopyIcon; 